module.exports = __webpack_public_path__ + "img/iran.99144475.png";